import {
  Card,
  CardActionArea,
  CardContent,
  Grid2,
  Typography,
} from "@mui/material";
import { ContentContainer } from "./ContentContainer";
import { SubSectionHeader } from "./SubSectionHeader";
import { useState } from "react";
import { ExperienceModal } from "./ExperienceModal";
import HoneyInsurance from "../asset/HoneyInsurance.jpeg";
import Canva from "../asset/Canva.png";
import Accenture from "../asset/Accenture.jpeg";
import AR from "../asset/AdviserRatings.png";

export type Work = {
  title: string;
  jobTitle: string;
  description: React.ReactElement;
  date: string;
  languages: string[];
  bgColor?: string;
  logo?: string;
};

const cards: Work[] = [
  {
    title: "Honey Insurance",
    jobTitle: "Software Engineer",
    date: "Feb 2023 - Feb 2024",
    languages: ["React JS", "Typescript", "AWS"],
    bgColor: "#FF514C",
    logo: HoneyInsurance,
    description: (
      <>
        I was part of the Honey's core claim management system streamlining
        claim lodgement and resolution from concept to deployment. I worked on
        integrations with multiple third party software to enable vendor
        allocations, claim lodgement, and email communications. <br />
        <br /> Outside of claim, I worked on optimising existing commission
        payment flow by implement cost adjustments for policies sold by
        distributors and conducted end to end testing.
        <br />
        <br />I collaborated closely with my designers and product managers to
        get the best product out the door.
      </>
    ),
  },
  {
    title: "Canva",
    jobTitle: "Software Engineer Intern",
    date: "Dec 2022 - Feb 2023",
    languages: ["React JS", "Typescript", "CSS", "MobX"],
    bgColor: "#26B5D1",
    logo: Canva,
    description: (
      <>
        I worked with Canva Presentation team on the Magic Cursor project. The
        existing magic cursor does not perform well when the CPU has been
        throttled. Initially it was implemented with Canvas. To fix the problem
        I created the cursor trail using plain HTML and CSS. I applied geometric
        sequence to generate a smoother and more fluid user experience. <br />
        <br /> To better understand the impact of my work and product
        requirements, I supported some customer interviews with teachers and
        educators.
      </>
    ),
  },
  {
    title: "Accenture",
    jobTitle: "Software Engineer Intern",
    date: "Dec 2021 - Dec 2022",
    languages: ["React JS", "HTML", "CSS", "Splunk", "AWS Cognito"],
    bgColor: "#A100FF",
    logo: Accenture,
    description: (
      <>
        I worked on the front end implement of a real time dashboard to help
        visualise cloud infrastructure performance for enterprise client. I've
        also worked on a project to implement a user authentication flow for a
        data visualisation tool using AWS Cognito.
      </>
    ),
  },
  {
    title: "Adviser Ratings",
    jobTitle: "Junior Developer",
    date: "Jul 2021 - Jul 2022",
    languages: ["Vue JS", "AWS"],
    bgColor: "#4A8BCA",
    logo: AR,
    description: (
      <>
        I was part of a team that help clean weekly data weekly. Then I joined
        the developer team for a few months and worked on some product features.
      </>
    ),
  },
];

export const WorkExperience = () => {
  const [selected, setSelected] = useState(0);
  const [visible, setVisible] = useState(false);

  return (
    <>
      <ExperienceModal
        isVisible={visible}
        close={() => setVisible(false)}
        jobInfo={cards[selected]}
      />
      <ContentContainer id="workExperience">
        <div style={{ textAlign: "left" }}>
          <SubSectionHeader
            title="Work Experience"
            subtitle="Professional experiences"
          />
          <Grid2
            container
            columnSpacing={2}
            rowSpacing={2}
            marginTop={2}
            flexDirection="column"
            sx={{
              display: { sm: "flex", md: "grid" },
              flex: 1,
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            {cards.map((card, index) => (
              <Grid2 key={index} flex={1} sx={{ gridColumn: "span 1" }}>
                <Card
                  sx={{
                    boxShadow: "none",
                    backgroundColor: "#F2EFEF",
                    borderRadius: 2,
                    flex: 1,
                  }}
                >
                  <CardActionArea
                    onClick={() => {
                      setSelected(index);
                      setVisible(true);
                    }}
                    data-active={selected === index ? "" : undefined}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        columnGap: 2,
                        alignItems: "center",
                      }}
                    >
                      <img
                        style={{
                          width: "90px",
                          height: "90px",
                          borderRadius: "100%",
                          textAlign: "center",
                          backgroundColor: "#D9D9D9",
                          border: "1px dashed white",
                        }}
                        src={card.logo}
                      />
                      <div>
                        <Typography variant="overline">{card.date}</Typography>
                        <Typography
                          variant="body1"
                          component="div"
                          fontWeight={700}
                        >
                          {card.title}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                          {card.jobTitle}
                        </Typography>
                      </div>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </div>
      </ContentContainer>
    </>
  );
};
